const PAGE_TYPES = {
  productList: 'Product list',
  productSummary: 'Product summary',
  assetList: 'Asset list',
  allAssets: 'All assets',
  assetDetails: 'Asset details',
};

export default PAGE_TYPES;
